<template>
  <button
    class="heart-btn"
    type="button"
    aria-label="收藏"
    @click.stop="onClick"
  >
    <svg viewBox="0 0 28 28" aria-hidden="true">
      <rect
        width="28"
        height="28"
        rx="6"
        :fill="active ? '#ff5b5b' : '#bfbfbf'"
      />
      <path
        :fill="active ? '#ffffff' : '#3b384a'"
        :transform="`translate(${2 + shiftX} 0)`"
        d="M14 21.4s-6.3-3.9-8.5-7.4C3.6 10.8 5.1 7.4 8.5 7.4c1.9 0 3.1 1.1 3.6 2 .5-.9 1.7-2 3.6-2 3.4 0 4.9 3.4 3 6.6-2.2 3.5-8.5 7.4-8.5 7.4z"
      />
    </svg>
  </button>
</template>

<script setup>
defineProps({
  active: { type: Boolean, default: false },
  shiftX: { type: Number, default: 0 }
})
const emit = defineEmits(['toggle'])

const onClick = () => {
  emit('toggle')
}
</script>

<style scoped>
.heart-btn {
  box-sizing: border-box;
  width: 19px;
  height: 19px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  vertical-align: middle;
}

.heart-btn svg {
  width: 19px;
  height: 19px;
  display: block;
  flex-shrink: 0;
}
</style>
